import { api } from "services/api.service";
import { AuthenticationContext } from "./useAuthentication";
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Role } from "types/role";
import TokenService from "services/token.service";

export type User = {
  id: number;
  uuid: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  /** Canonical organization subdomain for this portal user (from API). */
  organizationSubdomain?: string;
  role?: Role;
  termsAccepted?: boolean;
};

type CurrentUserContextValue = {
  currentUser?: User;
  role?: Role;
  setCurrentUser: (user: User | undefined) => void;
};

export const CurrentUserContext = createContext<CurrentUserContextValue>({
  currentUser: undefined,
  role: undefined,
  setCurrentUser: () => {},
});

export const CurrentUserProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [currentUser, setCurrentUser] = useState<User | undefined>(undefined);
  const { loggedIn, setLoggedIn } = useContext(AuthenticationContext);

  const getCurrentUser = useCallback(() => {
    api
      .get("/current_user")
      .then((response) => {
        setLoggedIn(true);
        setCurrentUser(response.data.user);
      })
      .catch(() => {
        // setLoggedIn(false);
        // TokenService.remove();
        // window.location.href = "/login";
      });
  }, [setLoggedIn]);

  useEffect(() => {
    if (!currentUser && loggedIn && TokenService.get()) {
      getCurrentUser();
    }
  }, [loggedIn, currentUser, getCurrentUser]);

  return (
    <CurrentUserContext.Provider
      value={{ currentUser: currentUser, role: currentUser?.role, setCurrentUser }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};

// Custom hook to use the CurrentUserContext
export const useCurrentUser = () => {
  return useContext(CurrentUserContext);
};
